import React from 'react';
import { TextInput } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Sizes = () => {
  return (
    <>
      <h4 className="mt-5">Sizes and Width</h4>
      <p>
        Get small to extraLarge text inputs easily by using the <i>size</i> prop.
        <br />
        Text Inputs are block elements. You can change the width of them using the <i>width</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <TextInput className="single-btn" placeholder="Type something..." size="small" />
     </div>
     <div className="mt-3">
        <TextInput className="single-btn" placeholder="Type something..." width='300px' size="extraLarge"/>
      </div>
      <Row className="mt-3">
        <code>
          {'import { TextInput } from "chic-ui";'}
          <br />
          {'<TextInput placeholder="Type something..." size="small" />'}
          <br />
          {'<TextInput  placeholder="Type something..." width="300px" size="extraLarge"/>'}
        </code>
      </Row>
    </>
  );
};

export default Sizes;
